import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";

export type SearchFieldProps = Omit<
  TextFieldProps,
  "variant" | "size" | "placeholder" | "InputProps"
> & {
  /** Fixed width in px. Defaults to 320. */
  width?: number;
};

/** Standard page search input — fixed width, shared icon treatment. */
export function SearchField({
  width = 320,
  sx,
  ...props
}: SearchFieldProps) {
  return (
    <TextField
      {...props}
      placeholder="Search"
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
      sx={{ width, ...sx }}
    />
  );
}

export default SearchField;
